/**
* NOTE: To use multiple jwPlayer-Instances at the same time, be sure that you create an individual container (e.g. own id)!
**/
(function(){
  'use strict';

  var jwplayer = require("jwplayer");

  var logger = new (require('../helpers/logger.js'))("VPJw").setColor("#0B7EF4").setDebug(true);
  var VideoPlayer = require('./videoplayer.js');
  var helper = require('../helpers/generic.js');
  var settings = require('../helpers/settings.js');

  module.exports = VPJw;

  var defaults = {
  };

  function VPJw(mediaInstance, inline, container, posterMediaImage, defaultQuality, options, playButtonImage, playButtonHoverImage){
    VideoPlayer.call(this, mediaInstance, inline, container, posterMediaImage, defaultQuality, defaults, options, playButtonImage, playButtonHoverImage);
    /*
    if (helper.undefOrNull(global.jwplayer)){
      global.jwplayer = {};
    }
    */
    logger.debug("initting jwplayer " + (inline? "inline" : "for overlay"));

    if (helper.undefOrNull(posterMediaImage) || this.options.omitPosterElement){ //otherwise init on play
      if (inline){
        this._initJwPlayer();
      }
    } else {
      this._initPoster();
    }
  }

  // subclass extends superclass
  VPJw.prototype = Object.create(VideoPlayer.prototype);
  VPJw.prototype.constructor = VideoPlayer;

  VPJw.prototype._getPlayerSources = function _getPlayerSources(){
    var sources = [];
    var defaultQuality = !helper.undefOrNull(this.defaultQuality) ? this.defaultQuality : this.media.defaultQualityName();
    var qualities = this.media.qualities();
    for (var i=0; i<qualities.length; i++){
      var qName = qualities[i];
      var url = this.media.qualityUrl(qName);
      if (!helper.undefOrNull(url)){
      // defaultQuality always needs to be the first element in the list or it needs a property 'default' set to true, so the 'HD'-Button will be grey when an SD-Video is played (if HD-Vid comes first the button would be inverted!)
      // NOTE: although we are setting a defaultQuality here, the played quality may differ as jwPlayer remembers the button state for all instances
        var isDefault = qName==defaultQuality;
        var src = { file: url, type: 'video/mp4', label: qName, 'default': isDefault };
        if (isDefault){
          logger.debug("adding default source", src);
          sources.unshift(src);
        } else {
          logger.debug("adding source", src);
          sources.push(src);
        }
      }
    }
    logger.debug("sources:", sources);
    return sources;
  };
  VPJw.prototype._getPlayerConfig = function _getPlayerConfig(){
      var vp = this;
      var jwSetup = {
        height: vp.media.height(vp.defaultQuality),
        width: vp.media.width(vp.defaultQuality),
        ga: {},
        autostart: false,
        provider: 'video',
        events: { //resize player according to video file
          onComplete: function(){
            vp._onVideoComplete();
          }
        },
        sources: vp._getPlayerSources()
      };

      if (this.inline && this.container.width() > 50 && this.container.height() > 50){ //dimensions of less than 50 are not supported for jwPlayer
        jwSetup.height = this.container.height();
        jwSetup.width = this.container.width();
      }
      if (!helper.undefOrNull(this.posterUrl)){
        jwSetup.image = this.posterUrl();
      }
      if (!this.inline){
        jwSetup.events.onMeta = function onMeta(event) {
          var metadata = event.metadata;
          if (!helper.undefOrNull(metadata) && !helper.undefOrNull(metadata.width) && !helper.undefOrNull(metadata.height)){ // Firefox
            doResize(metadata);
          } else if (!helper.undefOrNull(event.width) && !helper.undefOrNull(event.height)){ //Safari
            doResize(event);
          }
          function doResize(data){
            var width = data.width;
            var height = data.height;
            var dimensionsSet = !helper.undefOrNull(width) && !helper.undefOrNull(height);
            var dimensionsOk = width > 0 && height > 0;
            var dimensionsChanged = helper.undefOrNull(vp.width) || helper.undefOrNull(vp.height) || vp.width != width || vp.height != height;
            if(dimensionsSet && dimensionsOk && dimensionsChanged) {
              vp.width = width;
              vp.height = height;
              vp._onResize(width, height);
            }
          }
        };
      }

      logger.debug("Player-Config: ", jwSetup);
      return jwSetup;
  };


  // if playing in overlay or if a poster is displayed, the player needs to be initialized first
  // afterwards we can trigger the play command
  VPJw.prototype._play = function _play(){
    var self = this;
    var container = this.container;

    if (!this.inline || this.hasPoster()){ // init before play
      this._initJwPlayer();
    }
    var player = this.player;
    player.onReady(function(evt){ //play when initted
      logger.debug("jwplayer playing", container);
      player.play();
    });
  };

  // As we override the close method but do not want to copy the method body from
  // 'parent prototype', we just call it from here
  VPJw.prototype._onClose = function _onClose(){
    this.player.stop().remove();
    VideoPlayer.prototype._onClose.call(this);
    logger.debug("JWPlayer destroyed!");
  };

  VPJw.prototype._initJwPlayer = function _initJwPlayer(){
    var container = this.container instanceof require('jquery') ? this.container[0] : this.container;
    var jwSetup = this._getPlayerConfig();
    this.player = jwplayer(container).setup(jwSetup);
  };

  // When Video has reached its end
  VPJw.prototype._onVideoComplete = function _onVideoComplete(){
    if (this.inline && !helper.undefOrNull(this.poster) && !this.options.omitPosterElement){ // if playing inline and a poster was set on an own element, reset the container to the poster image
        logger.debug("jwplayer finished; Removing Player and displaying poster");
        this.player.stop().remove();
        this._initPoster();
    }
  };

  VPJw.prototype.resize = function resize(width, height){
    if (!helper.undefOrNull(this.player)){
      this.player.resize(width, height);
    }
  };

  VPJw.prototype.resizeForOverlay = function resizeForOverlay(width, height){
    if (!this.inline && !helper.undefOrNull(this.player)){
      this.player.resize(width, height);
    }
  };

  VPJw.prototype.resizeForInheritation = function resizeForInheritation(width, height){
    $(this.baseContainer).css({width: width+'px', height: height+'px'});
    if (this.inline){
      if (!helper.undefOrNull(this.player)){
        this.player.resize(width, height);
      } else {
        this.container.css({width: width+'px', height: height+'px'});
      }
    }
  };

}());



//////////////////
// WEBPACK FOOTER
// ./src/VideoPlayer/videoplayer_jw.js
// module id = 29
// module chunks = 0